import '../../styles/button.css';

import { Button } from '../generic/Button';
import { ButtonProps } from '../generic/Button';
import { ButtonSizes, ButtonTypes } from '../../consts/button';
import { Link } from 'gatsby';

/**
 * @todo Do not use button element inside links, rely on css.
 * @todo Remove this component in favor of using gatsby <Link> with proper classes.
 */
export interface BaseButtonLink {
  /**
   * Button link href
   */
  href: string;
}

export interface ButtonLinkProps extends Omit<ButtonProps, 'onClick'>, BaseButtonLink {}

export const ButtonLink = (
  {
    mode = ButtonTypes.PRIMARY,
    size = ButtonSizes.MEDIUM,
    label,
    className,
    href,
  }: ButtonLinkProps,
) => {
  const buttonComponent = (
    <Button
      mode={mode}
      size={size}
      label={label}
      className={className}
      onClick={() => undefined}
    />
  );
  return (
    href.startsWith('/') ? (
      <Link to={href} className='button-link'>
        {buttonComponent}
      </Link>
    ) : (
      <a href={href} className='button-link'>
        {buttonComponent}
      </a>
    )
  );
}
